import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => createStyles({
  inputWrapper: {
    marginBottom: 30,
  },
}), { name: 'VideoEditStepModal' });

export default useStyles;
